import { useDispatch } from 'react-redux';
// 使用类型化的 dispatch hook
export const useAppDispatch = () => useDispatch();
